import {XMarkIcon} from "@heroicons/react/24/solid/index.js";
import React from "react";

export const OverlayClose = ({className="top-4 right-4 text-white", close}) => {
    return (
        <div className={`absolute transition delay-75 duration-300 ease-in-out hover:rotate-180 font-extrabold cursor-pointer rounded-full flex items-center justify-center h-[35px] w-[35px] ${className}`} onClick={() => {close();}}><XMarkIcon/></div>
    )
}
